var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCaretRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.71019 6.71019L2.71019 10.7102C2.52188 10.8985 2.26649 11.0043 2.00019 11.0043C1.73388 11.0043 1.47849 10.8985 1.29018 10.7102C1.10188 10.5219 0.996094 10.2665 0.996094 10.0002C0.996094 9.73388 1.10188 9.47849 1.29018 9.29019L4.59019 6.00019L1.29018 2.71019C1.10188 2.52188 0.996094 2.26649 0.996094 2.00019C0.996094 1.86833 1.02206 1.73776 1.07253 1.61594C1.12299 1.49411 1.19695 1.38342 1.29018 1.29019C1.38342 1.19695 1.49411 1.12299 1.61594 1.07253C1.73776 1.02207 1.86833 0.996094 2.00019 0.996094C2.26649 0.996094 2.52188 1.10188 2.71019 1.29019L6.71019 5.29019C6.80391 5.38315 6.87831 5.49375 6.92908 5.61561C6.97985 5.73747 7.00598 5.86817 7.00598 6.00019C7.00598 6.1322 6.97985 6.2629 6.92908 6.38476C6.87831 6.50662 6.80391 6.61722 6.71019 6.71019Z",
    fill: "#6B7588"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretRight);
export default __webpack_public_path__ + "static/media/caret-right.0584d68ab8de0c3a60d6c3666c77d350.svg";
export { ForwardRef as ReactComponent };